<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.15698 11.913V9.63044M2.15698 11.913H1.16279C0.798256 11.913 0.5 11.6196 0.5 11.2609V9.95652C0.5 8.15652 1.98465 6.69565 3.81395 6.69565M2.15698 11.913L2.43203 14.9065C2.46186 15.2424 2.75017 15.5 3.09483 15.5H3.81395M2.15698 2.45652C2.15698 1.37717 3.04843 0.5 4.14535 0.5C5.24227 0.5 6.13372 1.37717 6.13372 2.45652M4.14535 5.3913H2.48837C2.12384 5.3913 1.82558 5.09783 1.82558 4.73913V2.45652H6.46512V4.08696M5.13954 7.67391H11.1047V9.63044H5.13954V7.67391ZM6.46512 5.71739H9.77907C9.77907 5.71739 11.1047 5.71739 11.1047 7.02174V13.5435C11.1047 13.5435 11.1047 14.8478 9.77907 14.8478H6.46512C6.46512 14.8478 5.13954 14.8478 5.13954 13.5435V7.02174C5.13954 7.02174 5.13953 5.71739 6.46512 5.71739Z"
      :stroke="color"
      stroke-miterlimit="10"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
